/** @jsxImportSource @emotion/react */

import { CSSObject } from '@emotion/react';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import { fonts } from '../../style/fonts';
import { colors } from '../../style/colors';

// Standalone, directly-linkable privacy page served at /privacy (NOT a popup). Rendered before the
// auth gate so it's reachable without a session — some stores (e.g. the Chrome Web Store) require a
// public URL that links straight to the privacy policy. "Back to login" returns to the app root.
const pageCss: CSSObject = {
  minHeight: '100%',
  background: colors.backgroundGrey,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '32px 16px 48px',
  overflowY: 'auto',
  '.card': {
    width: '100%',
    maxWidth: 820,
    background: colors.white,
    borderRadius: 12,
    padding: '28px 32px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  },
  '.title': {
    ...fonts.h1,
    color: colors.blue2,
    marginBottom: 16,
  },
  '.back-button': {
    ...(fonts.largeLabel as object),
    color: colors.blue3,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    padding: 0,
    marginBottom: 20,
  },
};

export default function PrivacyPolicyPage() {
  return (
    <div css={pageCss}>
      <div className="card">
        <button
          type="button"
          className="back-button"
          onClick={() => {
            // Hard navigation to the app root — the privacy page renders outside the Router, so
            // history.push isn't available here; a location change re-enters the auth flow.
            window.location.assign('/');
          }}
        >
          &lt; Back to login
        </button>
        <h1 className="title">Privacy Policy</h1>
        <PrivacyPolicyContent />
      </div>
    </div>
  );
}
